// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","left":"Footer_left__aLZA+","center":"Footer_center__Vj1d4","right":"Footer_right__ts+rg","socialIcon":"Footer_socialIcon__+HSoA"};